import { div } from '@mui/system'
import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilled, ButtonFilledAutoWidth } from '../../../components/button'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { CreateDepartmentService, UpdateDepartmentService } from '../../../services/DepartmentServices'
import { useNavigate, useLocation } from 'react-router-dom'
import { MobileBackOption } from '../../../components/appbars/mobile/DashboardMobile'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { message, Select } from 'antd'
import { CreateFollowupService, GetFollowupService, UpdateFollowupService } from '../../../services/admin/FollowupServices'
import { BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import { GetAllTemplateService } from '../../../services/TemplateServices'
import ErrorComponent from '../../../components/ErrorComponent'

function FollowUpCE() {
 
  const [data,setdata] = useState({days:'',scheduled_time:'',max_sent_times:'',message:'',interested_customer_days:0,non_interested_customer_days:0,followup_template:'',followup_template_list:[],interested_customer_scheduled_time:'',non_interested_customer_scheduled_time:'',is_active:false,no_of_users_to_send_at_once:0,call_time:'',rcs_time:''});  
  const [error,seterror] = useState({days:'',scheduled_time:'',max_sent_times:'',message:'',interested_customer_days:'',non_interested_customer_days:'',followup_template:'',followup_template_list:'',interested_customer_scheduled_time:'',non_interested_customer_scheduled_time:'',no_of_users_to_send_at_once:'',call_time:'',rcs_time:''}); 
  
  const [templateMessageArr, settemplateMessageArr] = useState([])


  const {state} = useLocation();
  const navigate = useNavigate();


  useEffect(()=>{
    // if(state?._id !== null && state?._id !== undefined){
    //   setdata({...data,...state})
    // }
    getTemplateMessage()
    getdata()

  },[state])

   async function getdata() {
      const response = await GetFollowupService()
      if(response?.data?.datas?.length > 0){
          let d = response?.data?.datas[0]
          let arr = []

          // console.log("d?.followup_template_list",d?.followup_template_list)
          d?.followup_template_list?.forEach((d1)=>(
             arr?.push({label:d1?.name,value:d1?._id})
          ))
          setdata({...d,followup_template:{label:d?.followup_template?.name,value:d?.followup_template?._id},followup_template_list:arr})
      }
    }

  async function getTemplateMessage(){
      const response = await GetAllTemplateService()
      let arr = []
      response?.data?.datas?.forEach((d)=>{
        arr?.push({label:d?.name,value:d?._id})
      })
      settemplateMessageArr(arr)
    }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    // if(!data.interested_customer_days){
    //     seterror({...error,interested_customer_days:'Interested Customer Days field is required *'})
    // }else if(!data.non_interested_customer_days){
    //     seterror({...error,non_interested_customer_days:'Non Interested Customer Days field is required *'})
    // }else if(!data.interested_customer_scheduled_time){
    //     seterror({...error,interested_customer_scheduled_time:'Interested Customer Scheduled Time field is required *'})
    // }else if(!data.non_interested_customer_scheduled_time){
    //     seterror({...error,non_interested_customer_scheduled_time:'Non Interested Customer Scheduled Time field is required *'})
    // }
    // else if(!data.followup_template){
    //     seterror({...error,followup_template:'This field is required *'})
    // }
    if(!data.days){
      seterror({...error,days:'Days field is required *'})
    }else if(!data.no_of_users_to_send_at_once){
      seterror({...error,no_of_users_to_send_at_once:'No of user to send at once *'})
    }else if(!data.scheduled_time){
      seterror({...error,scheduled_time:'Schedule Time field is required *'})
    }else if(!data.call_time){
      seterror({...error,call_time:'Call Time field is required *'})
    }else if(!data.rcs_time){
      seterror({...error,rcs_time:'RCS Time field is required *'})
    }else{
        let sendData = {...data}
        if(data?.followup_template?.value){
          sendData['followup_template'] = data?.followup_template?.value
        }else{
          delete sendData?.followup_template
        }

        if(data?.followup_template_list?.length > 0){
          sendData['followup_template_list'] = data?.followup_template_list?.map((v)=>v?.value)
        }else{
          sendData['followup_template_list'] = []
        }

        sendData['max_sent_times'] = sendData['followup_template_list']?.length


        if(data?._id === undefined || data?._id === sendData){
        const response = await CreateFollowupService(data)
        if (response.status === 201) {
          // resetform()
          toast.success('FollowUp Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,days:response?.data?.errors?.days})
        } 
      }else{
         let sendData = {...data}
        if(data?.followup_template?.value){
          sendData['followup_template'] = data?.followup_template?.value
        }else{
          delete sendData?.followup_template
        }

        if(data?.followup_template_list?.length > 0){
          sendData['followup_template_list'] = data?.followup_template_list?.map((v)=>v?.value)
        }else{
          sendData['followup_template_list'] = []
        }
        sendData['max_sent_times'] = sendData['followup_template_list']?.length

        const response = await UpdateFollowupService(sendData,data?._id)
        if (response.status === 200) {
          // resetform()
          toast.success('FollowUp Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,days:response?.data?.errors?.days})
        } 
      }
      getdata()
  }
  }


  function resetform(){
    setdata({days:'',scheduled_time:'',max_sent_times:'',message:'',interested_customer_days:0,non_interested_customer_days:0,followup_template:'',followup_template_list:[],interested_customer_scheduled_time:'',non_interested_customer_scheduled_time:'',is_active:false,no_of_users_to_send_at_once:0,call_time:'',rcs_time:''})
    seterror({days:'',scheduled_time:'',max_sent_times:'',message:'',interested_customer_days:'',non_interested_customer_days:'',followup_template:'',followup_template_list:[],interested_customer_scheduled_time:'',non_interested_customer_scheduled_time:'',no_of_users_to_send_at_once:'',call_time:'',rcs_time:''})
  }
  

  function setfollowuptemplate_list(v){
    console.log("v",v)

    let arr = []
    v.forEach((d)=>{
      arr?.push(templateMessageArr?.find((f)=>f?.value === d))
    })

    console.log("arr",arr)
    setdata({...data,followup_template_list:arr})
  }

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(data?._id !== null && data?._id !== undefined) ? 'Edit' : 'Add'} FollowUp Template</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> FollowUp Template</b> for your clients followup.</h6>
     
     <TextInput 
            label={'Days'}  
            variant="standard"
            name="days"
            type="number"
            error={error.days}
            value={data.days}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

        {/* <TextInput 
            label={'Days'}  
            variant="standard"
            name="days"
            type="number"
            error={error.days}
            value={data.days}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

             <TextAreaInput1 
            label={'Message'}  
            variant="standard"
            name="message"
            type="text"
            error={error.message}
            value={data.message}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/> */}


            {/* <TextInput 
            label={'Max Times Send'}  
            variant="standard"
            name="max_sent_times"
            type="number"
            error={error.max_sent_times}
            value={data.max_sent_times}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/> */}

            <TextInput 
            label={'No of User To Send At Once'}  
            variant="standard"
            name="no_of_users_to_send_at_once"
            type="number"
            error={error.no_of_users_to_send_at_once}
            value={data.no_of_users_to_send_at_once}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

             <TextInput 
            label={'Schedule Time (Whatsapp Template)'}  
            variant="standard"
            name="scheduled_time"
            type="time"
            error={error.scheduled_time}
            value={data.scheduled_time}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

           <TextInput 
            label={'Schedule Time (RCS Message)'}  
            variant="standard"
            name="rcs_time"
            type="time"
            error={error.rcs_time}
            value={data.rcs_time}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

             <TextInput 
            label={'Schedule Time (Voice Call)'}  
            variant="standard"
            name="call_time"
            type="time"
            error={error.call_time}
            value={data.call_time}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            {/* <TextInput 
            label={'Interested Customer Days'}  
            variant="standard"
            name="interested_customer_days"
            type="number"
            error={error.interested_customer_days}
            value={data.interested_customer_days}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            <TextInput 
            label={'Non Interested Customer Days'}  
            variant="standard"
            name="non_interested_customer_days"
            type="number"
            error={error.non_interested_customer_days}
            value={data.non_interested_customer_days}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            <TextInput 
            label={'Interested Customer Schedule Time'}  
            variant="standard"
            name="interested_customer_scheduled_time"
            type="time"
            error={error.interested_customer_scheduled_time}
            value={data.interested_customer_scheduled_time}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            <TextInput 
            label={'Non Interested Customer Schedule Time'}  
            variant="standard"
            name="non_interested_customer_scheduled_time"
            type="time"
            error={error.non_interested_customer_scheduled_time}
            value={data.non_interested_customer_scheduled_time}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/> */}

          {/* <h6 className='text-[11px] mb-1 mt-2 font-[700]'>Select Template</h6>
          <Select 
            placeholder={'Template'} 
            value={data?.followup_template == '' ? null : data?.followup_template}
            options={templateMessageArr}
            bordered={false}
            onChange={(e)=>setdata({...data,followup_template:templateMessageArr?.find((f)=>f?.value === e)})}
            className='border rounded-[6px] w-[100%] mr-1 border-slate-300'
          /> 
          <ErrorComponent  error={error?.template_message} /> */}


           <h6 className='text-[11px] mb-1 mt-2 font-[700]'>Select Template</h6>
          <Select 
            placeholder={'Template List'} 
            value={data?.followup_template_list == '' ? null : data?.followup_template_list}
            options={templateMessageArr}
            bordered={false}
            mode="multiple"
            onChange={(e)=>setfollowuptemplate_list(e)}
            className='border rounded-[6px] w-[100%] mr-1 border-slate-300'
          /> 
          <ErrorComponent  error={error?.followup_template_list} />

            <div onClick={()=>setdata({...data,is_active:!data.is_active})} className='flex items-center mt-2 mr-2'>
              {data?.is_active ?  <BiCheckboxSquare size={22} className='text-slate-800' />  : <BiCheckbox size={22} className='text-slate-300'  /> }
              <h6 className="text-[10px] font-[600] ml-1">Is Active</h6> 
            </div> 

        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(data?._id !== null && data?._id !== undefined) ? "UPDATE FOLLOWUP" : "ADD FOLLOWUP"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default FollowUpCE